import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap'
import ButterToast, { Cinnamon } from 'butter-toast'
import { client } from '@Utils'
import { useStateValue } from '../../../state'
import { ltiOrgKeyManagement as endpoints } from '@URLS'

export const DevKeyForm = props => {
  const [currentState, dispatch] = useStateValue()

  const [appName, updateAppName] = useState('')
  const [trustedUrl, updateTrustedUrl] = useState('')
  const [appId, updateAppId] = useState('')
  const [appKey, updateAppKey] = useState('')
  const [entityDomain, updateEntityDomain] = useState('')

  const handleAppNameChange = e => {
    updateAppName(e.target.value)
  }

  const handleTrustedUrlChange = e => {
    updateTrustedUrl(e.target.value)
  }

  const handleAppIdChange = e => {
    updateAppId(e.target.value)
  }

  const handleAppKeyChange = e => {
    updateAppKey(e.target.value)
  }

  const handleEntityDomainChange = e => {
    updateEntityDomain(e.target.value)
  }

  const AddDevKey = async () => {
    try {
      let resp = await client.post(
        endpoints.addDevKey({ orgId: props.organization.id }),
        {
          appName: appName,
          trustedUrl: trustedUrl,
          appId: appId,
          appKey: appKey,
          entityDomain: entityDomain,
        }
      )
      ButterToast.raise({
        content: (
          <Cinnamon.Crisp
            title="Success"
            content="Successfully added new context."
            scheme={Cinnamon.Crisp.SCHEME_BLUE}
            icon={<i className="far fa-thumbs-up fa-3x" />}
          />
        ),
      })
      props.toggle(false)
      props.setOrganization(resp.data.organization)
      dispatch({ type: 'reload', reload: !currentState.reloadSwitch })
    } catch (err) {
      console.log(err)
      ButterToast.raise({
        content: (
          <Cinnamon.Crisp
            title="Success"
            content="There was an error trying to create a new context."
            scheme={Cinnamon.Crisp.SCHEME_RED}
            icon={<i className="far fa-thumbs-down fa-3x" />}
          />
        ),
      })
    }
  }

  return (
    <Fragment>
      <FormGroup controlId="appName">
        <ControlLabel>App Name</ControlLabel>
        <FormControl
          type="text"
          onChange={handleAppNameChange}
          value={appName}
        />
      </FormGroup>
      <FormGroup controlId="trustedUrl">
        <ControlLabel>Trusted URL</ControlLabel>
        <FormControl
          type="text"
          onChange={handleTrustedUrlChange}
          value={trustedUrl}
        />
      </FormGroup>
      <FormGroup controlId="appId">
        <ControlLabel>App ID</ControlLabel>
        <FormControl type="text" onChange={handleAppIdChange} value={appId} />
      </FormGroup>
      <FormGroup controlId="appKey">
        <ControlLabel>App Key</ControlLabel>
        <FormControl type="text" onChange={handleAppKeyChange} value={appKey} />
      </FormGroup>
      <FormGroup controlId="entityDomain">
        <ControlLabel>Entity Domain</ControlLabel>
        <FormControl
          type="text"
          onChange={handleEntityDomainChange}
          value={entityDomain}
        />
      </FormGroup>
      <div
        className="btn btn-success btn-myed btn-success-myed"
        onClick={() => AddDevKey()}
      >
        <div className="far fa-plus fa-fw mr-2" /> Add Dev Key
      </div>
    </Fragment>
  )
}

DevKeyForm.propTypes = {
  organization: PropTypes.object.isRequired,
  setOrganization: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
}
